export const dummySubscriptions = Array.from({ length: 50 }, (_, i) => ({
  _id: `sub_${i + 1}`,
  customerName: `Customer ${i + 1}`,
  email: `customer${i + 1}@mail.com`,
  planType: i % 2 === 0 ? "Monthly" : "Annual",
  status: i % 3 === 0 ? "Active" : "Expired",
  startDate: new Date(2024, 5, i + 1).toISOString(),
  endDate: new Date(2024, 6, i + 1).toISOString(),
  couponCode: i % 5 === 0 ? `COUPON${i + 1}` : "-",
}));
